// extracted by mini-css-extract-plugin
module.exports = {"donationForm":"DonationTable_donationForm__1Qwz8","submitButton":"DonationTable_submitButton__GRfOk"};